import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Seo from "@/components/Seo";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-5 py-28 text-center" data-testid="payment-cancel-page">
      <Seo title="Payment Cancelled" path="/payment/cancel" noindex />
      <XCircle className="w-14 h-14 text-muted-foreground mx-auto mb-6" />
      <h1 className="font-display text-4xl font-light">Checkout cancelled</h1>
      <p className="text-muted-foreground mt-3">No charge was made. Your cart is still saved.</p>
      <Link to="/shop" className="mt-8 inline-flex font-mono-label text-xs bg-primary text-primary-foreground px-6 py-3 rounded-full hover:brightness-110 transition-[filter]">
        Back to shop
      </Link>
    </div>
  );
}
